import React from 'react';
import { Section } from '../layout/Section';
import contentData from '../../data/content.json';

export const OeffnungszeitenSection: React.FC = () => {
  const { openingHours } = contentData.contact;

  return (
    <Section id="oeffnungszeiten" variant="darker" aria-labelledby="oeffnungszeiten-heading">
      <div className="max-w-md mx-auto text-center">
        <h2
          id="oeffnungszeiten-heading"
          className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-4"
        >
          Öffnungszeiten
        </h2>
        <div className="w-24 h-1 bg-[#c9a84c] mx-auto rounded-full mb-10" aria-hidden="true" />

        <div className="bg-black/70 border border-[#c9a84c]/30 rounded-xl overflow-hidden shadow-2xl">
          <div className="h-1 bg-gradient-to-r from-transparent via-[#c9a84c] to-transparent" aria-hidden="true" />
          <ul className="divide-y divide-white/5 px-8 py-4">
            {openingHours.map(({ day, hours }) => {
              const closed = hours === 'Geschlossen';
              return (
                <li key={day} className="flex justify-between items-center py-3">
                  <span className={`font-medium ${closed ? 'text-gray-500' : 'text-white'}`}>
                    {day}
                  </span>
                  <span className={closed ? 'text-gray-600 italic text-sm' : 'text-[#c9a84c] font-semibold'}>
                    {hours}
                  </span>
                </li>
              );
            })}
          </ul>
          <div className="h-1 bg-gradient-to-r from-transparent via-[#c9a84c] to-transparent" aria-hidden="true" />
        </div>
      </div>
    </Section>
  );
};
